export const blockIconsCommunicationPhoneInTalkNew = (
	<span className='material-symbols-outlined'>phone_in_talk</span>
);
